// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__jsRlO","filesListContainer":"PosDisputesFiles_filesListContainer__absXl","filesButton":"PosDisputesFiles_filesButton__20OGl"};